import { type Reducer, createStore as _createStore, applyMiddleware, combineReducers, compose } from 'redux';
import { withExtraArgument } from 'redux-thunk';

import { defaultBannersState, defaultLocationsState, defaultResidentialComplexesState } from 'shared/__mocks__/store';
import { filterReducer, noopReducer, residentialComplexesIdsReducer } from 'shared/reducers';
import { specialPromosBlocksReducer } from 'shared/reducers/specialPromosBlocks';
import { type IApplicationContext } from 'shared/types/applicationContext';
import { type IApplicationState, type TReduxActions, type TReduxStore } from 'shared/types/redux';

let storeReminder: TReduxStore;

interface ICreateReduxStore {
  initialState: IApplicationState;
  debugEnabled?: boolean;
  context: IApplicationContext;
}

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 * @param context – IApplicationContext
 * @param debugEnabled – включение дебаг мода
 */
export function createReduxStore({ initialState, context, debugEnabled }: ICreateReduxStore): TReduxStore {
  const reducers = combineReducers({
    adfox: noopReducer(initialState.adfox),
    banners: noopReducer(defaultBannersState),
    filter: filterReducer,
    locations: noopReducer(defaultLocationsState),
    residentialComplexes: noopReducer(defaultResidentialComplexesState),
    residentialComplexesIds: residentialComplexesIdsReducer,
    specialPromosBlocks: specialPromosBlocksReducer,
    user: noopReducer(initialState.user),
  }) as unknown as Reducer<IApplicationState, TReduxActions>;

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const middlewares = [withExtraArgument(context)];

  const storeEnchancers = composeEnhancers(
    compose(applyMiddleware(...middlewares)),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) as any;

  const createStore = (): TReduxStore =>
    _createStore<IApplicationState, TReduxActions>(reducers, initialState, storeEnchancers);

  if (process.env.NODE_ENV === 'development' && debugEnabled) {
    if (!storeReminder) {
      storeReminder = createStore();
    }

    storeReminder.replaceReducer(reducers);

    return storeReminder;
  }

  return createStore();
}
